module.exports = __webpack_public_path__ + "src/assets/ar.ae8995cc.png";